import styled, { css } from 'styled-components';
import Button from "components/Button";

export const Container = styled.div`
  .wrapper {
    display: flex;
    flex-direction: column;
    padding: 2rem 3rem;
    height: 100vh;
    overflow-y: scroll;
  }
`

export const SearchBarContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
`

export const DisplaySelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  p {
    color: var(--white);
    align-self: flex-start;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.6rem;
`

type propsButton = {
  selected?: boolean
}

export const StyledButton = styled(Button) <propsButton>`
  width: 10rem;
  font-size: 14px;

  ${({ selected }) => selected && css`
    background: var(--black-400);
      color: var(--white);
        &:hover {
          background: var(--black-200);
          color: var(--white) !important;
        }
      }
  `}

  &:hover {
    background: #d6a606;
    color: var(--black-100) !important;
  }
`

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-auto-flow: row dense;
  width: 100%;
  margin-top: 2rem;
  grid-gap: 1.5rem;

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1366px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (min-width: 1880px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`
